import React, { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import { IS_PRERENDER } from "@/lib/faro";

// Click-to-load Google Maps facade: saves ~500KB of third-party JS per map on initial load.
// With `autoLoad`, the iframe loads itself when the map scrolls near the viewport (no click needed).
export const LazyMap = ({ src, title, className = "", testid = "lazy-map", autoLoad = false }) => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!autoLoad || loaded || IS_PRERENDER || !ref.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setLoaded(true);
          obs.disconnect();
        }
      },
      { rootMargin: "400px" }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [autoLoad, loaded]);

  if (loaded) {
    return (
      <iframe
        title={title}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        src={src}
        data-testid={testid}
        className={className}
      />
    );
  }

  return (
    <button
      ref={ref}
      type="button"
      onClick={() => setLoaded(true)}
      data-testid={`${testid}-placeholder`}
      className={`w-full h-full min-h-[220px] flex flex-col items-center justify-center gap-2 bg-[var(--faro-blue)] faro-grid-bg text-white hover:brightness-110 transition ${className}`}
      aria-label={`Cargar mapa: ${title}`}
    >
      <span className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center">
        <MapPin size={22} className="text-[var(--faro-yellow)]" />
      </span>
      <span className="font-bold text-sm">{title}</span>
      <span className="text-xs px-3 py-1.5 rounded-full bg-white text-[var(--faro-blue)] font-black uppercase tracking-wider">
        Toca para ver el mapa
      </span>
    </button>
  );
};
